import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  Action as GradProgramAction,
  gradProgramsReducer as gradPrograms,
} from './gradPrograms';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  Action as IntegrationsAction,
  integrationsReducer as integrations,
} from './integrations';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  Action as ListingsAction,
  listingsReducer as listings,
} from './listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as OrgAction, orgsReducer as orgs } from './orgs';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as SearchAction, searchReducer } from './search';

export type Action =
  | GradProgramAction
  | ListingsAction
  | OrgAction
  | SearchAction;

export const orgDashboardReducer = combineReducers<
  {
    orgs: typeof orgs;
    listings: typeof listings;
    search: typeof searchReducer;
    gradPrograms: typeof gradPrograms;
    integrations: typeof integrations;
  },
  | OrgAction
  | ListingsAction
  | SearchAction
  | GradProgramAction
  | IntegrationsAction
>({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  orgs,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  listings,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  search: searchReducer,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  gradPrograms,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  integrations,
});
